import React, { useState, useEffect } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import moment from "moment";
import { Link as RouterLink } from "react-router-dom";

import { getInitials } from "helpers";
import { connect } from "react-redux";
import * as actions from "redux/actions/discoverActions";

import MiniLoader from "components/MiniLoader";
import StockAvatar from "components/StockAvatar";
import { Translate, I18n } from "react-redux-i18n";

import { Trash, Star} from "theme/icon";

const useStyles = {
  root: {},
  content: {
    padding: 0,
  },
  inner: {
    minWidth: 1050,
  },
  nameContainer: {
    display: "flex",
    alignItems: "center",
  },
  actions: {
    justifyContent: "center",
  },
  avatar: {
    marginRight: '7px',
    height: 25,
    width: 25,
    flexDirection: 'row',
    position: "absolute",
    borderRadius: "5px"
  },
};

const stylesLocal = {
  subcell: {
    padding: "5px"
  },
  cell: {
    padding: "5px"
  }
};

function pl(items) {
  var pl = 0;
  items.map(item => {
    pl = pl + (item.open_trade + item.close_trade - item.tax);
  });
  return pl.toFixed(2);
}

const Table_ = (props) => {
  const { className, list, history, ...rest } = props;

  const [selectedList, setSelectedList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);

  const [filters, setFilters] = useState({
    search: "",
  });

  const handleSelectAll = (event) => {
    const { list } = props;

    let selectedList;

    if (event.target.checked) {
      selectedList = list.map((item) => item.id);
    } else {
      selectedList = [];
    }
    setSelectedList(selectedList);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedList.indexOf(id);
    let newSelectedList = [];

    if (selectedIndex === -1) {
      newSelectedList = newSelectedList.concat(selectedList, id);
    } else if (selectedIndex === 0) {
      newSelectedList = newSelectedList.concat(selectedList.slice(1));
    } else if (selectedIndex === selectedList.length - 1) {
      newSelectedList = newSelectedList.concat(selectedList.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedList = newSelectedList.concat(
        selectedList.slice(0, selectedIndex),
        selectedList.slice(selectedIndex + 1)
      );
    }

    setSelectedList(newSelectedList);
  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value);
  };

  const onClickIn = (item) => {
    // props.setPatient(item);
  };

  const onClickDelete = (item) => {
    props.removeItem(props.token, { patient_id: item.id, id: props.user_id });
  };

  const onClickLoadMore = () => {
    if (props.loadingMore || props.pageSize < 25) {
      return;
    }
    props.loadMore(
      {
        index: props.list.length,
        id: props.user_id,
      },
      props.token,
    );
  };

  useEffect(() => {
    props.loadList({ id: props.user_id }, props.token);
    //props.loadListEarning({ id: props.user_id }, props.token);
  }, []);

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const normalizedSearch = filters.search.toLowerCase();
  const filteredList = list.filter((item) => {
    if (!normalizedSearch) return true;
    return (
      item.symbol.toLowerCase().includes(normalizedSearch) ||
      (item.name && item.name.toLowerCase().includes(normalizedSearch)) ||
      (item.exchange && item.exchange.toLowerCase().includes(normalizedSearch))
    );
  });

  return (
    <div className="">
        <div className={''}>
        
          <table className="table table-hover discover-table">
            <thead>
              <tr>
                <th align="left">Symbol</th>
                <th>Name</th>
                <th>Exchange</th>
                <th align="right">Last</th>
                <th align="right">Dividend</th>
                <th align="right">Payment date</th>
                <th align="right">Ex-dividend date</th>
                <th align="right">Declaration</th>
                <th align="right">Frequency</th>
              </tr>
            </thead>
            <tbody>
              {filteredList.map((item, rowIndex) => (
                <tr
                  className={''}
                  hover
                  key={`${item.symbol}-${item.dividend_ex_date || rowIndex}`}
                  selected={selectedList.indexOf(item.id) !== -1}
                >
                  {/* {console.log(item)} */}
                  <td >
                    <div className="symbol-cell">
                      <StockAvatar item={item} symbol={item.symbol} className="avatar-sm" />
                      <div className="symbol-meta">
                        <RouterLink
                          to={"/stock/" + item.symbol}
                          className="symbol-link"
                        >
                          {item.symbol.toUpperCase()}
                        </RouterLink>
                        {item.dividend === '1' && (
                          <Star className="symbol-star"/>
                        )} 
                      </div>
                    </div>
                  </td>
                  <td style={stylesLocal.cell}>{item.name}</td>
                  <td style={stylesLocal.cell}>{item.exchange}</td>
                  <td style={stylesLocal.cell} align="right">
                    {'$ '}{item.price}
                  </td>
                  <td style={stylesLocal.cell} align="right">
                    {'$ '}{item.dividend_amount}
                  </td>
                  <td  style={stylesLocal.cell} align="right">
                    {moment(item.dividend_pay_at).zone("+00:00").format('DD/MM/YYYY')}
                  </td>
                  <td style={stylesLocal.cell} align="right">
                    {moment(item.dividend_ex_date).zone("+00:00").format('DD/MM/YYYY')}
                  </td>
                  <td style={stylesLocal.cell} align="right">
                    {moment(item.dividend_declaration).zone("+00:00").format('DD/MM/YYYY')}
                  </td>
                  <td style={stylesLocal.cell} align="right">
                    {item.dividend_frequency}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      <div className="discover-table-footer">
        {props.pageSize === 25 && (
          props.loadingMore ? (
            <MiniLoader />
          ) : (
            <button className="btn btn-primary" onClick={onClickLoadMore}>
              <Translate value="load_more" />
            </button>
          )
        )}
      </div>
    </div>
  );
};

Table_.propTypes = {
  className: PropTypes.string,
  list: PropTypes.array.isRequired,
  history: PropTypes.object
};

function mapStateToProps(reducer) {
  //console.log(reducer);
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,

    auth: reducer.session.auth,

    list: reducer.discover.list,
    error: reducer.discover.error,
    loading: reducer.discover.loading,

    loadingMore: reducer.discover.loadingMore,
    pageSize: reducer.discover.page_size,
    pageCount: reducer.discover.page_count,

  };
}

const mapDispatchToProps = dispatch => ({
  loadList: (params, token) =>
    dispatch(actions.loadListDividend({ params, token })),
  loadMore: (params, token) =>
    dispatch(actions.loadListDividendScroll({ params, token })),

});
export default connect(mapStateToProps, mapDispatchToProps)(Table_);
/**.slice((page * rowsPerPage), (rowsPerPage * (page + 1)))
 *  <TablePagination
          component="div"
          count={list.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
 * <TableCell>
                      {item.year}
                    </TableCell>
                    <TableCell>
                      {item.color}
                    </TableCell>
                     <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedList.length === list.length}
                      color="primary"
                      indeterminate={
                        selectedList.length > 0 &&
                        selectedList.length < list.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>

                   <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedList.indexOf(item.id) !== -1}
                        color="primary"
                        onChange={(event) => handleSelectOne(event, item.id)}
                        value="true"
                      />
                    </TableCell>
 */
